import {Box} from '@mui/material';

export const TextCell = ({value}: {value: string}) => (
  <Box className={`care-table-row-cell care-table-row-cell-text`}>
    <p>{value}</p>
  </Box>
);
